import { Biotech as AgroIcon, CleaningServices, DiamondOutlined, Inventory, PrecisionManufacturing as MachineryIcon, Build as MaintenanceIcon } from "@mui/icons-material";
import { SxProps, Tooltip } from "@mui/material";
import ProductionIcon from "images/production";
import { FunctionComponent } from "react";
import { TASK_SCOPE } from "types/Task";



interface Props {
	scope: string
	group?: string
	sx?: SxProps
}

const ScopeIcon: FunctionComponent<Props> = ({
	scope,
	group,
	sx
}) => {

	// HANDLER

	// RENDER
	if (!scope) return null
	const tooltip = `${scope.toUpperCase()}${group ? " / " + group.toUpperCase() : ""}`

	let Icon = {
		[TASK_SCOPE.PRODUCTION]: <ProductionIcon style={{ width: "24px", height: "24px", ...sx } as React.CSSProperties} />,
		[TASK_SCOPE.PACKAGING]: <Inventory sx={sx} />,
		[TASK_SCOPE.CLEANING]: <CleaningServices sx={sx} />,
		[TASK_SCOPE.MAINTENANCE]: <MaintenanceIcon sx={sx} />,
		[TASK_SCOPE.QUALITY]: <DiamondOutlined sx={sx} />,
		[TASK_SCOPE.AGRO]: <AgroIcon style={{ width: "24px", height: "24px", ...sx } as React.CSSProperties} />,
		[TASK_SCOPE.MACHINERY]: <MachineryIcon sx={sx} />,
	}[scope]

	return (
		<Tooltip title={tooltip}>
			<div style={{ display: "flex" }}>
				{Icon}
			</div>
		</Tooltip>)
}

export default ScopeIcon
